import screenProps from '../screenProps'
import fetch from '../Services/fetch'

export default (props) => (dispatch) => {

  screenProps(props)

  dispatch(fetch())

}
